import axios from 'axios'
import router from '../router/index'
// import router from '../router/index'
// import store from '../store/index'

import Vue from 'vue'
import iView from 'iview'
Vue.use(iView)

// axios 配置  timeout单位为毫秒
var timeOut = 1000 * 60 * 30
axios.defaults.timeout = timeOut
axios.defaults.baseURL = process.env.API_HOST + '/api'
axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
}

// axios.defaults.transformRequest = [function (data) {
//   data = Qs.stringify(data)
//   return data
// }]
// axios.defaults.withCredentials = true

// http request 拦截器
var num = 0
axios.interceptors.request.use(
    config => {
        num++
        if (sessionStorage.demoSpinIconLoad === 'true') {
            Vue.prototype.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'load-a',
                                size: 36
                            }
                        })
                    ])
                }
            })
            sessionStorage.demoSpinIconLoad = 'true'
        } else {
            sessionStorage.demoSpinIconLoad = 'true'
        }
        if (localStorage.token) {
            config.headers.Authorization = 'SperogenixAuthentication ' + localStorage.token
            config.headers['Accept-Language'] = localStorage.getItem('currentLanguage') === null ? 'zh-CN' : localStorage.getItem('currentLanguage') === 'mergeZH' ? 'zh-CN' : 'en-US'
            config.headers['route'] = sessionStorage.route
        }
        config.data = JSON.stringify(config.data)
        return config
    },
    err => {
        return Promise.reject(err)
    }
)
// http response 拦截器
axios.interceptors.response.use(
    response => {
        num--
        if (num <= 0) {
            Vue.prototype.$Spin.hide()
        }
        if (response.status === 204) {

        } else {
            return response
        }
    },
    error => {
        num--
        if (num <= 0) {
            Vue.prototype.$Spin.hide()
        }
        if (error.response) {
            switch (error.response.status) {
            case 500:
                if (error.response.data) {
                    let duration = 5
                    if (error.response.config.responseType === 'arraybuffer') {
                        let unit8Arr = new Uint8Array(error.response.data)
                        let encodedString = String.fromCharCode.apply(null, unit8Arr)
                        let decodedString = decodeURIComponent(escape((encodedString)))
                        Vue.prototype.$Message.error({
                            content: JSON.parse(JSON.parse(decodedString)).Message,
                            duration: 5
                        })
                    } else {
                        if (JSON.parse(error.response.data).Message.length > 20) {
                            duration = 8
                        }
                        Vue.prototype.$Message.error({
                            content: JSON.parse(error.response.data).Message,
                            duration: duration
                        })
                    }
                } else {
                    Vue.prototype.$Message.error({
                        content: '请求服务器被拒绝，请清空浏览器缓存后重试',
                        duration: 3
                    })
                }
                break
            case 400:
                if (error.response.data) {
                    let duration = 5
                    if (error.response.config.responseType === 'arraybuffer') {
                        let unit8Arr = new Uint8Array(error.response.data)
                        let encodedString = String.fromCharCode.apply(null, unit8Arr)
                        let decodedString = decodeURIComponent(escape((encodedString)))
                        Vue.prototype.$Message.error({
                            content: JSON.parse(JSON.parse(decodedString)).Message,
                            duration: 5
                        })
                    } else {
                        if (JSON.parse(error.response.data).Message.length > 20) {
                            duration = 8
                        }
                        Vue.prototype.$Message.info({
                            content: JSON.parse(error.response.data).Message,
                            duration: duration
                        })
                    }
                } else {
                    Vue.prototype.$Message.error({
                        content: '当前操作引发未知错误，请联系管理员',
                        duration: 3
                    })
                }
                break
            case 401:
                if (error.response.data === '用户身份信息已过期。') {
                    localStorage.clear()
                    router.push({ name: 'loginJump', params: { code: 'system.userIdentityExpired' } })
                } else {
                    if (error.response.data) {
                        Vue.prototype.$Message.error({
                            content: '没有权限访问',
                            duration: 3
                        })
                    } else {
                        Vue.prototype.$Message.error({
                            content: error.response.data,
                            duration: 3
                        })
                    }

                    router.push({ path: '/403' })
                }
                break
            case 404:
                Vue.prototype.$Message.error({
                    content: '找不到访问的资源',
                    duration: 3
                })
                break
            case 405:
                Vue.prototype.$Message.error({
                    content: '访问失败，请联系管理员',
                    duration: 5
                })
                break
            default:
                Vue.prototype.$Message.error({
                    content: '未知错误',
                    duration: 3
                })
                break
            }
        } else {
            Vue.prototype.$Message.error({
                content: '未知错误',
                duration: 3
            })
        }
        return Promise.reject(error)
    }
)
export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js